import React from "react";
import injectSheet from "react-jss";
import NumberFormat from "react-number-format";
import {
	Col,
	OfferBudget,
	OfferConfiguration,
	OfferContact,
	OfferHouseType,
	OfferLayout,
	Row,
	TitleContainer,
} from "../../";
import { roundToNearest } from "../../budget/selectors";

const Offer = (props) => {
	const {
		budgetSelection,
		clientSelection,
		classes,
		configurationSelection,
		houseTypeSelection,
		offer,
		plotSelection,
	} = props;

	return (
		<TitleContainer
			className={`${classes.container}`}
			title={offer.config.title}
		>
			<div className={`${classes.offerTileContainer}`}>
				<Row>
					<Col elements={2}>
						<OfferHouseType houseTypeSelection={houseTypeSelection} />
					</Col>
					<Col elements={2}>
						<OfferContact clientSelection={clientSelection} />
					</Col>
				</Row>

				<Row classes={[classes.offerHeaderContainer]}>
					<Col>
						<h2 className={`${classes.offerTitle}`}>Meine Voraussetzungen</h2>
					</Col>
				</Row>

				<Row classes={[classes.offerHeaderContainer]}>
					<Col>
						<OfferBudget
							budgetSelection={budgetSelection}
							houseTypeSelection={houseTypeSelection}
							plotSelection={plotSelection}
							configurationSelection={configurationSelection}
						/>
					</Col>
				</Row>

				<Row>
					<Col>
						<h4 className={`${classes.offerTitle}`}>
							Grundriss
							<NumberFormat
								displayType="text"
								value={
									houseTypeSelection.layout
										? roundToNearest(houseTypeSelection.layout.price, 3)
										: 0
								}
								thousandSeparator="'"
								prefix=" ("
								suffix={` ${budgetSelection.currency})`}
							/>
						</h4>
						<OfferLayout
							budgetSelection={budgetSelection}
							houseTypeSelection={houseTypeSelection}
						/>
					</Col>
				</Row>

				<Row>
					<Col>
						<h4 className={`${classes.offerTitle}`}>
							Konfiguration
							<NumberFormat
								displayType="text"
								value={roundToNearest(configurationSelection.price, 3)}
								thousandSeparator="'"
								prefix=" ("
								suffix={` ${budgetSelection.currency})`}
							/>
						</h4>
						<OfferConfiguration
							budgetSelection={budgetSelection}
							configurationSelection={configurationSelection}
						/>
					</Col>
				</Row>

				<Row>
					<Col>
						<h2 className={`${classes.offerTitle}`}>
							Richtangebot: ca.
							<NumberFormat
								displayType="text"
								prefix=" "
								suffix={` ${budgetSelection.currency}`}
								thousandSeparator="'"
								value={budgetSelection.totalReached}
							/>
						</h2>
						<p className={`${classes.disclaimer}`}>
							(Diese Preise dienen als Richtpreise und können später abweichen)
						</p>
					</Col>
				</Row>
			</div>
		</TitleContainer>
	);
};

const styles = (theme) => ({
	container: {
		height: "100%",
	},
	offerTileContainer: {
		margin: `0px ${theme.sizes.gutter / 2}px`,
		padding: `${theme.sizes.gutter}px 0`,
		backgroundColor: theme.colors.main_2,
		color: theme.colors.secondary_3b,
		height: "100%",
	},
	offerTitle: {
		padding: `${theme.sizes.gutter / 2}px`,
		marginBottom: 0,
	},
	imageContainer: {
		height: "300px",
		padding: `${theme.sizes.gutter / 2}px`,
	},
	disclaimer: {
		fontWeight: "bold",
		marginTop: 0,
		padding: `0 ${theme.sizes.gutter / 2}px`,
	},
	offerHeaderContainer: {
		backgroundColor: "#e6e6e6",
	},
});

export default injectSheet(styles)(Offer);



// WEBPACK FOOTER //
// ./src/modules/offer/components/offer.jsx